import { Component, Inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './core/header/header.component';
import { AuthService } from './auth/auth.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { environment } from '../environments/environment';
@Component({
  imports: [ RouterModule,  HeaderComponent, CommonModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'scio-nav';
  userDetails: any;
  isAuthenticated: boolean = false;
  
  constructor(private authService: AuthService, @Inject(DOCUMENT) private document: Document) {    
    const firebaseAppJunction = environment.firebaseAppJunction || '/';
    const baseHref = firebaseAppJunction && firebaseAppJunction.replace("/**", "/");
    const base = this.document.querySelector('base');
    if (base) {
      base.setAttribute('href', baseHref);
    }
  }

  ngOnInit(): void {  
    this.getTokenDetails()  
  }

  async getTokenDetails() { 
    this.isAuthenticated = false;  
    try {
     await this.authService.loginWithMic().then(res=>{
        if(res) {
          this.userDetails = res;
          this.isAuthenticated = true
        }
      });
      
    } catch (error) {
      console.error('Error getting token details:', error);
    }
  }

}
